module.exports = __webpack_public_path__ + "static/media/mockup.12e5e1bf.jpg";